import { gql, useMutation } from "@apollo/client";

const DELETE_ADMIN_USER_MUTATION = gql`
  mutation DeleteAdminUser($_id: ID!) {
    deleteAdminUser(_id: $_id)
  }
`;

export const useDeleteAdminUserMutation = () => {
  const [deleteAdminUserMutation, { loading, error, data }] = useMutation(
    DELETE_ADMIN_USER_MUTATION,
    {
      refetchQueries: ['GetAllAdminUsers'],
      awaitRefetchQueries: true,
    }
  );

  const deleteAdminUser = async (_id: string) => {
    try {
      const { data } = await deleteAdminUserMutation({
        variables: { _id },
      });
      return data?.deleteAdminUser;
    } catch (error) {
      console.error("Error deleting admin user:", error);
      throw error;
    }
  };

  return { deleteAdminUser, loading, error, data };
};


